import {Component, OnDestroy, OnInit} from '@angular/core';
import {UserService} from "../../../core/user/services/user.service";
import {UserModel} from "../../../core/user/user.model";
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {UserDataChangeComponent} from "../user-data-change/user-data-change.component";
import {PasswordChangeComponent} from "../password-change/password-change.component";

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    standalone: false
})
export class UserComponent implements OnDestroy, OnInit {
  public user: UserModel | null = null;
  private ngUnsubscribe$ = new Subject<void>();
  public alert: string = '';
  public errorMessage: string = '';
  public notification = {html: '', type: ''};
  public showNotification = false;

  constructor(private userService: UserService,
              public dialog: MatDialog
  ) {
  }

  ngOnInit() {
    this.user = this.userService.getUser();
    if (!this.user) {
      this.userService.loadUser()?.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((user: any) => {
        this.user = user.userResponse?.user;
      })
    }
  }

  openUserDataChangeDialog() {
    const userDataDialogConfig = new MatDialogConfig();
    userDataDialogConfig.autoFocus = true;
    // userDataDialogConfig.minWidth = '50vw';
    userDataDialogConfig.width = '35rem';
    // userDataDialogConfig.minHeight = 'auto';
    userDataDialogConfig.data = {
      salutation: this.user?.salutation.toUpperCase(),
      title: this.user?.title,
      first_name: this.user?.name,
      last_name: this.user?.last_name
    };

    this.dialog.open(UserDataChangeComponent, userDataDialogConfig).afterClosed()
    .pipe(takeUntil(this.ngUnsubscribe$)).subscribe(result => {
      if (result.data === 'success') {
        this.notification = {
          html: 'Die Daten werden erflogreich geändert.',
          type: 'info'
        };
      }  else if (result.data) {
        this.notification = {
          html: 'Die Stammdaten konnten nicht geändert werden.',
          type: 'warn'
        };
      }
      this.notify();
      }
    )
  }

  openPasswordChangeDialog() {
    const passwordDialogConfig = new MatDialogConfig();
    passwordDialogConfig.autoFocus = true;
    // userDataDialogConfig.minWidth = '50vw';
    passwordDialogConfig.width = '35rem';
    passwordDialogConfig.data = {
      newPass: true
    };
    // userDataDialogConfig.minHeight = 'auto';

    this.dialog.open(PasswordChangeComponent, passwordDialogConfig).afterClosed()
    .pipe(takeUntil(this.ngUnsubscribe$)).subscribe((result: any) => {
      if (result.data === 'success') {
        this.notification = {
          html: 'Der Password wurde erflogreich geändert.',
          type: 'info'
        };
      }
      else if (result.data) {
        this.notification = {
          html: 'Der Password konnte nicht geändert werden. Haben Sie das richtige alte Passwort eingegeben?',
          type: 'warn'
        };
      }
      this.notify();
    })
  }

  notify() {
    this.showNotification = true;
    setTimeout(() => {
      this.showNotification = false;
    }, 4000);
  }


  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
